import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

function PriorityAct() {
    return (
        <SettingsMetaData propertyName={"PriorityAct"} viewPropertyName={"Priority"} />
      );
}

export default PriorityAct
